import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'

import type { PeriodSelectedDataProps } from '@pages/Preview/context/types'
import type { AdjustPreviewFormProps } from './types'
import type { AdjustPreviewListResponseProps } from '@services/api/preview/types'

export const setInitialValues = (
  data?: PeriodSelectedDataProps | null,
  adjustPreviewListData?: AdjustPreviewListResponseProps[] | null,
  accountOptions?: { code: string; name: string }[]
) => {
  // O cabeçalho só pode exibir uma única semana quando todos os ajustes listados
  // pertencem à mesma semana. Com múltiplas semanas na lista (filtro "Todos"), usar
  // o primeiro item mentiria sobre a semana dos demais — cada linha exibe a sua própria.
  const distinctWeeks = Array.from(
    new Set((adjustPreviewListData ?? []).map((item) => item.weekNumber).filter((week) => week != null))
  )
  const weekLabel =
    distinctWeeks.length === 1 ? `Semana ${distinctWeeks[0]}`
    : distinctWeeks.length > 1 ? 'Todos'
    : ''

  const parsedData: AdjustPreviewFormProps = {
    period: data?.competencePeriod?.label || '',
    dateCompetence: data?.competenceDate ? formattedDatePtBr(data.competenceDate) : '',
    week: weekLabel,
    accounts: adjustPreviewListData?.length
      ? adjustPreviewListData.map((account) => {
          const matchingAccount = accountOptions?.find((option) => option.name === account.accountName)

          return {
            account: matchingAccount?.code ?? account.accountName,
            accountId: account.id.toString(),
            week: account.weekNumber != null ? `Semana ${account.weekNumber}` : '',
            adjustmentValue: account.adjustmentAmount.toFixed(2),
            observations: account.observations,
            creationUserCode: account.creationUserCode
          }
        })
      : [
          {
            account: '',
            accountId: '',
            week: '',
            adjustmentValue: '',
            observations: ''
          }
        ]
  }

  return parsedData
}
